module.exports = __webpack_public_path__ + "images/ideal-7GQJu6_.svg";